export default class maxChoice {
	constructor(checkboxgroup) {
		this.checkboxgroup = checkboxgroup;
		this.maxCount = checkboxgroup.dataset.maxChoices;
		this.inputs = this.checkboxgroup.querySelectorAll('input[type="checkbox"]');
		this.checkboxgroup.addEventListener('change', this.checkMaxCount.bind(this));
	}

	checkMaxCount() {
		const checkedCheckboxesAmount = this.checkboxgroup.querySelectorAll('input[type="checkbox"]:checked').length;

		if (checkedCheckboxesAmount == this.maxCount) {
			this.disableCheckboxes();
		}
		if (checkedCheckboxesAmount < this.maxCount) {
			this.enableCheckboxes();
		}
	}

	disableCheckboxes() {
		this.checkboxgroup.querySelectorAll('input[type="checkbox"]:not(:checked)').forEach((element) => {
			element.setAttribute('disabled', '');
		});
	}

	enableCheckboxes() {
		this.inputs.forEach((element) => {
			element.removeAttribute('disabled', '');
		});
	}
}
